const TEXT_STYLE_MAP = {
  questions_group: 'H2',
  list: 'H3',
  error: 'ERROR',
  normal: 'NORMAL',
  label: 'LABEL',
  heading: 'HEADING',
  review_heading: 'REVIEW_HEADING',
};

export default TEXT_STYLE_MAP;
